import moment from 'moment'

// let ordersCache = null

export default {
  methods: {
    _doAnonymousLogin () {
      return this.$http.post('auth/anonymous', {}, this.completeHttpParams({})).then(response => response.body)
      /* return new Promise((resolve, reject) => {
        return resolve({
          "Token": "beb17a0b-f6ea-4c00-87cc-fb4e6482365e",
          "SatispayAvailable": true
        })
      }) */
    },
    _doUserLogin (email, password) {
      return this.$http.post('auth/user', { email, password }, this.completeHttpParams({})).then(response => response.body)
    },
    _refreshToken () {
      return this.$http.get('auth/refresh', this.completeHttpParams({})).then(response => response.body)
    },
    _doUserRegistrationWithMedia (userdata) {
      return this.$http.post('user/setregistrationcsc', userdata, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _doUserRegistrationWithoutMedia (userdata) {
      console.log('_doUserRegistrationWithoutMedia', userdata)
      return this.$http.post('user/setregistration', userdata, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _doUserPreRegistration (userdata) {
      return this.$http.post('user/preregistration', userdata, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _completeRegistration (email, registrationToken) {
      return this.$http.post('user/acceptregistration', { email, registrationToken }, this.completeHttpParams({ emulateJSON: true })).then(response => response.body)
    },
    _askPasswordReinitialization (email) {
      return this.$http.post('user/askreinitializepassword', { email }, this.completeHttpParams({})).then(response => response.body)
    },
    _completePasswordReinitialization (email, restoreToken, newPassword) {
      return this.$http.post('user/reinitializepassword', { email, restoreToken, newPassword }, this.completeHttpParams({})).then(response => response.body)
    },
    _changePassword (login, oldPassword, newPassword) {
      return this.$http.post('user/changepassword', { login, oldPassword, newPassword }, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _getUserProfileImage () {
      return this.$http.post('user/photo', {userCode: this.user.UserAccountCode }, this.completeHttpParams({})).then(response => {
        return response.body
      })
    },

    _setUserProfileImage (image) {
    return this.$http.put('user/updatephoto', { userCode: this.user.UserAccountCode , photo:image}, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _getUserProfile () {
      return this.$http.post('user/details', { userCode: this.user.UserAccountCode }, this.completeHttpParams({})).then(response => {
        /* if (response.body && response.body.birthDate) {
          response.body.birthDate = moment(response.body.birthDate).format('YYYY-MM-DD')
        } */
        return response.body
      })
    },
    _getUserCSCList () {
      return this.$http.post('user/medias', { userCode: this.user.UserAccountCode }, this.completeHttpParams({})).then(response => {
        return response.body/*.map(el => {
          return {
            ...el,
            canAddProduct: false
          }
        }) */
      })
    },
    _getUserCSCDetails (mediaSerialNumber, mediaUnicity) {
      return this.$http.post('sales/managermediasdetails', { mediaSerialNumber, mediaUnicity }, this.completeHttpParams({})).then(response => {
        return response.body
      })
    },
    _saveUserIdentity (IdentityUserInfo) {
      IdentityUserInfo = { ...IdentityUserInfo }
      if (IdentityUserInfo && IdentityUserInfo.birthDate) {
        IdentityUserInfo.birthDate = moment(IdentityUserInfo.birthDate).format('YYYY-MM-DD')
      }
      return this.$http.put('user/updateidentityinfo', { IdentityUserInfo, userCode: this.user.UserAccountCode }, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    },
    _getUserPayments (start, size) {
      return this.$http.get('sales/orders', this.completeHttpParams({ params: { start, size }, headers: { userCode: this.user.UserAccountCode } })).then(response => {
        /*ordersCache = */return response.body.filter(ord => ord.Status !== 2)
        // return ordersCache
      })
    },/*
    _getUserPayment (OrderId) { // Not used!
      return new Promise.resolve(ordersCache ? ordersCache.find(oc => oc.OrderId === OrderId) : null)
    } */
    _saveUserAddresses (AddressInfo) {
      return this.$http.put('user/updateaddressinfo', { AddressInfo, userCode: this.user.UserAccountCode }, this.completeHttpParams({ emulateJSON: false })).then(response => {
        return response.body
      })
    },
    _getDataList (dataType) {
      return this.$http.get('commons/datalist', this.completeHttpParams({ headers: { dataType } })).then(response => {
        return response.body
      })
    },
    _suspendContract (ContractId, MediaSerialNumber, MediaUnicity, Cause, EndDate) {
      return this.$http.post('aftersale/suspendcontract', {
        MediaSerialNumber, MediaUnicity, ContractId, Cause, EndDate,
        "MediaType": "Csc",
        "SuspensionType": 'Temporary'
        // "StartDate": "2020-12-07T10:23:33.386Z"
      }, this.completeHttpParams({ emulateJSON: false })).then(response => {
        return response.body
      })
    },
    _blacklistCSC (MediaSerialNumber, MediaUnicity, cause) {
      return this.$http.post('aftersale/blacklistmedia', {
        MediaSerialNumber, MediaUnicity, cause,
        "MediaType": "Csc",
        "SuspensionType": 'Temporary'
        // "StartDate": "2020-12-07T10:23:33.386Z",
        // "EndDate": "2020-12-07T10:23:33.386Z"
      }, this.completeHttpParams({ emulateJSON: false })).then(response => {
        return response.body
      })
    },
    _askMailUpdate (newEmail) {
      return this.$http.post('user/askupdateemail', { newEmail }, this.completeHttpParams({})).then(response => response.body)
    },
    _confirmMailUpdate (newEmail, token, guid) {
      return this.$http.post('user/confirmupdateemail', { newEmail, guid }, this.completeHttpParams({ headers: { loginToken: token } })).then(response => response.body)
    },
    _getRelativeUsers () {
      return this.$http.post('user/relativeusers', {  userCode: this.user.UserAccountCode }, this.completeHttpParams({headers: { userCode: this.user.UserAccountCode}})).then(response => {
        return response.body
      })
    },

    _getUserByFiscalCode (fiscalCode) {
       return this.$http.post('user/search', { fiscalCode: fiscalCode,userCode:this.user.UserAccountCode  }, this.completeHttpParams({})).then(response => {
         return response.body
       })
 
     },

     _addRelativeUser (request) {
      return this.$http.post('user/link',       
          request
      , this.completeHttpParams({ emulateJSON: false })).then(response => {
        return response.body
      })      
    },
     
     
    _removeRelativeUser(request){
      return this.$http.post('user/removelink', request
      , this.completeHttpParams({ emulateJSON: false })).then(response => {
        return response.body
      })      
    },
 

    _acceptRelativeUser(userdata) {
      console.log('_acceptRelativeUser', userdata)
      return new Promise((resolve, reject) => {
        setTimeout(resolve(
         ), Math.random() * 1000)
      })
      /*
      return this.$http.post('user/setregistration', userdata, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
      */
    }

  }
}